import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import {
  ComponentType,
  Portal,
  ComponentPortal,
  DomPortalHost
} from '@angular/cdk/portal';
import { RelatorioVisualizadorComponent } from './relatorio-visualizador/relatorio-visualizador.component';
import { RelatorioRequisicao } from './modelos/relatorio-requisicao';
import { catchError, EMPTY, Observable, Subject } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Toast } from '@syncfusion/ej2-angular-notifications';
import { ToastService } from '../libs/toast/toast.service';
import { UrlService } from '../servicos/url.service';

@Injectable()
export class RelatorioService {
  private visualizador: RelatorioVisualizadorComponent | null = null;

  constructor(
    private http: HttpClient,
    private appRef: ApplicationRef,
    private url: UrlService,
    private toast: ToastService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) { 
    var cp = new ComponentPortal(RelatorioVisualizadorComponent);
    let host = new DomPortalHost(
      document.body,
      this.componentFactoryResolver,
      this.appRef,
      this.injector);

    this.visualizador = host.attach(cp).instance;
  }

  public visualizarPdf(pdf: Blob, titulo: string = 'Relatório') {
    if(!this.visualizador)
      return;

    this.visualizador.titulo = titulo;
    this.visualizador.resetarArquivo();
    this.visualizador.abrirTelaCheia();

    this.visualizador.inserirArquivo(pdf);
  }

  public visualizarRelatorio(requisicaoRequisicao: RelatorioRequisicao<Object>, titulo: string = 'Relatório') {
    if(!this.visualizador)
      return;

    this.visualizador.titulo = titulo;
    this.visualizador.resetarArquivo();
    this.visualizador.abrirTelaCheia();

    this.consultarRelatorio(requisicaoRequisicao);
  }

  public visualizarDocumento(documentoId: string, senha: string | null, titulo: string | null = null) {
    if(!this.visualizador)
      return;

    if(titulo === null)
      titulo = `Documento #${documentoId}`;

    this.visualizador.titulo = titulo;
    this.visualizador.resetarArquivo();
    this.visualizador.abrirTelaCheia();
    
    this.consultarDocumento(documentoId, senha);
  }

  private consultarRelatorio(requisicao: RelatorioRequisicao<Object>) {
    let params = new HttpParams();
    
    Object.keys(requisicao.consulta)
    .forEach(key => {
      params = params.append(key, (requisicao.consulta as any)[key]);
    });

    this.http.get(requisicao.url, { params: params, responseType: 'blob' })
    .pipe(
      catchError(async (err: HttpErrorResponse) => {
        if ((err as any)['_handled']) return EMPTY;

        let text = err.error.text ? await err.error.text() : '';
        let error = text ? JSON.parse(text) : null;

        if(error != null && error.mensagens && error.mensagens.length > 0) {
          let erros = error.mensagens as string[];
          erros.join(', ');
          this.toast.showWarning('Ops, não foi possível realizar a emissão.<br/><b>' + erros.join(', ')+'</b>');
          throw err;
        }

        this.toast.showError('Ops, ocorreu um problema ao executar esta operação. ' +
        'Tente novamente mais tarde.');
        throw err;
      })
    )
    .subscribe((arq: Blob | Observable<never>) => {
      if (!(arq instanceof Blob)) return;

      this.visualizador?.inserirArquivo(arq);
    });
  }

  private consultarDocumento(documentoId: string, senha: string | null) {
    let params = new HttpParams();
    
    if(senha !== null)
      params = params.append(`senha`, senha);

    this.http.get(this.url.url(`interno/arquivos/restritos/${documentoId}`, 'docs'), { params: params, responseType: 'blob' })
    .pipe(
      catchError(async (err: HttpErrorResponse) => {
        if ((err as any)['_handled']) return EMPTY;

        let text = await err.error.text();
        let error = JSON.parse(text);

        if(err.status === 404) {
          this.toast.showWarning(`Ops, não foi possível possível consultar o documento ${documentoId}. Verifique se o mesmo não está anulado.`);
          throw err;
        }

        this.toast.showError('Ops, ocorreu um problema ao executar esta operação. ' +
        'Tente novamente mais tarde.');
        throw err;
      })
    )
    .subscribe((arq: Blob | Observable<never>) => {
      if (!(arq instanceof Blob)) return;

      this.visualizador?.inserirArquivo(arq);
    });
  }
}
